import type {
  AIRepository,
  GetTrackPayload,
} from '../../../network/repositories/aiRepository';
import type { AIService } from '../aiService';

export default class AIServiceImpl implements AIService {
  aiRepository: AIRepository;

  constructor(aiRepository: AIRepository) {
    this.aiRepository = aiRepository;
  }

  getAIGeneratedSong(payload: GetTrackPayload) {
    const { aiRepository } = this;
    return aiRepository.getAIGeneratedSong(payload);
  }
}
